import * as Types from '../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type FetchUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FetchUserQuery = { __typename?: 'Query' } & {
    user?: Types.Maybe<
        { __typename?: 'User' } & Pick<
            Types.User,
            | 'loggedIn'
            | 'name'
            | 'email'
            | 'status'
            | 'senderPropertyStatus'
            | 'userId'
            | 'userUuid'
            | 'creationDate'
            | 'brandPrimary'
            | 'registrationSources'
            | 'registered'
        >
    >;
};

export const FetchUserDocument = gql`
    query fetchUser {
        user {
            loggedIn
            name
            email
            status
            senderPropertyStatus
            userId
            userUuid
            creationDate
            brandPrimary
            registrationSources
            registered
        }
    }
`;

/**
 * __useFetchUserQuery__
 *
 * To run a query within a React component, call `useFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUserQuery(
    baseOptions?: Apollo.QueryHookOptions<
        FetchUserQuery,
        FetchUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<FetchUserQuery, FetchUserQueryVariables>(
        FetchUserDocument,
        options
    );
}
export function useFetchUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FetchUserQuery,
        FetchUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<FetchUserQuery, FetchUserQueryVariables>(
        FetchUserDocument,
        options
    );
}
export type FetchUserQueryHookResult = ReturnType<typeof useFetchUserQuery>;
export type FetchUserLazyQueryHookResult = ReturnType<
    typeof useFetchUserLazyQuery
>;
export type FetchUserQueryResult = Apollo.QueryResult<
    FetchUserQuery,
    FetchUserQueryVariables
>;
